<template>
   <node-view-wrapper class="card">
      <header>
         <h3>Illustratie</h3>
         <button @click="remove"><span class="material-icons">close</span></button>
      </header>
      
      <div style="margin-top: 2rem">{{ node.attrs.naam }}</div>
      <div class="content">
         <div class="row">
            <label>Naam</label>
            <input type="text" v-model="node.attrs.naam" />
         </div>
         <div class="row">
            <label>Breedte</label>
            <input type="text" v-model="node.attrs.breedte" />
         </div>
         <div class="row">
            <label>Hoogte</label>
            <input type="text" v-model="node.attrs.hoogte" />
         </div>
         <div class="row">
            <label>Uitlijning</label>
            <input type="text" v-model="node.attrs.uitlijning" />
         </div>
         <div class="row">
            <label>formaat</label>
            <input type="text" v-model="node.attrs.formaat" />
         </div>
         <div class="row">
            <label>Alt</label>
            <input type="text" v-model="node.attrs.alt" />
         </div>
         <div class="row">
            <label>Dpi</label>
            <input type="text" v-model="node.attrs.dpi" />
         </div>
      </div>
   </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from "@tiptap/vue-2";

export default {
   components: {
      NodeViewWrapper,
   },
   props: ["node", "updateAttrs", "editable", "view", "getPos"],
   //  props: nodeViewProps,

   methods: {
      increase() {
         this.updateAttributes({
            count: this.node.attrs.count + 1,
         });
      },
      remove() {
         // get some node view props
         // depends on your setup (vue, react)
         const { editor, getPos, node } = this;

         const from = getPos();
         const to = from + node.nodeSize;

         editor.commands.deleteRange({ from, to });
      },
   },
};
</script>

<style scoped lang="scss">
.card {
   border: 1px solid #ddd;
   border-radius: 0.5rem;
   margin: 1rem 0;
   position: relative;
   width: 98%;
   max-width: 1200px;
}

header {
   display: grid;
   grid-template-columns: 1fr auto;
   grid-gap: 1rem;
   align-items: center;
   padding: 1rem;
   border-bottom: 1px solid #ddd;
   h3 {
      margin: 0;
      padding: 0;
   }
   button {
      background-color: transparent;
      border: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
         background-color: #f2f2f2;
      }
   }
}

</style>